




























import { Component, Vue } from "vue-property-decorator";
import { AlertItem } from "@/response";
import { ActionTypes } from '@/store/aciton-types';

@Component
export default class AlertComponent extends Vue {
  get alert(): AlertItem {
    if ((<any>this.$store.state).alert.show === true) {
      setTimeout(() => {
        this.closeAlert();
      }, 5000);
    }
    return (<any>this.$store.state).alert;
  }

  closeAlert() {
    this.$store.dispatch(ActionTypes.CLOSE_ALERT);
  }

  beforeMount() {}
}
